import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";

let Editbbps = () => {
  const location = useLocation();
  const state = location.state;
  let navigate = useNavigate();

  const [data, setData] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const [ser, setUsr] = useState(false);
  const [ddta, setDdta] = useState();
  const [one, setOne] = useState();
  let [count, setCount] = useState();

  let [ value, inputvalue] = useState();

  let [sel, setSel] = useState();

  const [text, setText] = useState("");

  const [val, setVal] = useState(0);

  const [vals, setVals] = useState("Success");

  const togglePanel = async (tt) => {
    setOne(tt);

    console.log(tt); 

    setIsOpen(true);
  };

  useEffect(() => {
    console.log(state , 'statestate')
    Start();
  }, []);

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  const handlePageClick = async (event) => {
    console.log(state, "state");
    setVal(event.selected);
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/alldata",
      data: {
        name: state,
        limit: 10,
        skip: event.selected,
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);
        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  let Start = async () => {
    console.log(state, "state");

    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/bbpsbillers",
      data: {
        name: state, 
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);

        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
          setText(Jsson?.text);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  let retry = async (tt) => {
    let foo = prompt("Type here");

    if (foo === text) {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      setUsr(true);
      let pp = { token, value: tt };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/retry",
        data: {
          value: tt,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          setUsr(false);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            // window.location.reload();
          } else {
            alert(Jsson.message);
          }
          // window.location.reload();
        })
        .catch((ee) => {
          setUsr(false);
          console.log(ee, "rrrrrrrrrrrrrrrrr");
        });
    } else {
      setUsr(false);
      alert("Plz Contact The admin");
    }
  };

  let submit = async () => {
    console.log(one, vals);

    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/creditcardupdate",
      data: {
        _id: one._id,
        value: vals,
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);
        setUsr(false);
        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          // window.location.reload();
        } else {
          alert(Jsson.message);
        }
        window.location.reload();
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  };

  // useEffect(() => {
  //   Filter();
  // }, [sel]);

  let Filter = async (seee) => {
    if (seee === "All") {
      Start();
    } else { 


      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      let pp = { token, name: state , type : seee };
      let data = await AesEncrypt(pp);
  
      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/onedatass",
        data: {
          name: state,
          limit: 10,
          skip: 0,
          type : seee
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
  
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson?.count);
            setText(Jsson?.text);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {
          console.log(ee, "rrrrrrrrrrrrrrrrr");
        });
    }
  };

  let searchss = async () =>{
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }
    let pp = { token, name: state  };
    let data = await AesEncrypt(pp);

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/admin/searchh",
      data: {
        name: state,
        limit: 10,
        skip: 0,
        type : value
      },
    })
      .then((dat) => {
        let parsedata = AesDecrypt(dat.data);
        let Jsson = JSON.parse(parsedata);

        console.log(Jsson, "Jsson");
        if (Jsson.status === true) {
          setData(Jsson.data);
          setCount(Jsson?.count);
          setText(Jsson?.text);
        } else {
          alert(Jsson.message);
        }
      })
      .catch((ee) => {
        console.log(ee, "rrrrrrrrrrrrrrrrr");
      });
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10">
          <div style={{ padding: 20 }}>
         

            {state === "Credit Card" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Card Detail</th>
                      <th scope="col">Payment Detail</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }
                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>
                            <div>
                              <p>Name : {tt?.user?.name }</p>
                              <p>Phone No : {tt?.user?.phoneno }</p>
                              <p>Email : {tt?.user?.email }</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>
                                Mobile Number :{" "}
                                {tt?.creditCardHistory?.customerNumber }
                              </p>
                              <p>
                                Last 4 card Degit :{" "}
                                {tt?.creditCardHistory?.last4Digits }
                              </p>
                              <p>
                                Pg transaction Id :{" "}
                                {tt?.pg_transactionId }
                              </p>
                              <p>Xopay Id : {tt?.xopayid }</p>

                              <p>
                                Payment Method :{" "}
                                {paymensss?.data?.payment?.payment_group ||
                                  "NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount }</p>
                              <p>Con Fess : ₹ {tt?.confess }</p>
                              <p>Total : ₹ {tt?.total }</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p
                                style={{
                                  color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                      ? "green"
                                      : "orange",
                                }}
                              >
                                {tt?.payment_status_msg }
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Broadband Postpaid" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User Detail</th>
                      <th scope="col">Card Detail</th>
                      <th scope="col">Payment Detail</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }
                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>
                            <div>
                              <p>Name : {tt?.user?.name }</p>
                              <p>Phone No : {tt?.user?.phoneno }</p>
                              <p>Email : {tt?.user?.email }</p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>
                                billNumber :{" "}
                                {tt?.creditCardHistory?.billNumber }
                              </p>
                              <p>
                                billDate :{" "}
                                {tt?.creditCardHistory?.billDate }
                              </p>

                              <p>
                                Pg transaction Id :{" "}
                                {tt?.pg_transactionId }
                              </p>
                              <p>Xopay Id : {tt?.xopayid }</p>

                              <p>
                                Payment Method :{" "}
                                {paymensss?.data?.payment?.payment_group ||
                                  "NA"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p>Amount : ₹ {tt?.amount }</p>
                              <p>Con Fess : ₹ {tt?.confess }</p>
                              <p>Total : ₹ {tt?.total }</p>
                              <p>
                                Time :{" "}
                                {convertAndFormatTimestamp(tt?.createdAt) ||
                                  "NA"}{" "}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div>
                              <p
                                style={{
                                  color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                      ? "green"
                                      : "orange",
                                }}
                              >
                                {tt?.payment_status_msg }
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : state === "Fastag" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Total</th>
                      <th scope="col">Date</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      console.log(tt);
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }

                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>{tt?.phone }</td>
                          <td>
                            <p>
                              Pg transaction Id : {tt?.pg_transactionId }
                            </p>
                            <p>Xopay Id : {tt?.xopayid }</p>

                            <p>
                              Payment Method :{" "}
                              {paymensss?.data?.payment?.payment_group }
                            </p>
                            <p style={{ fontWeight : '700' }}>₹ {tt?.total }</p>
                          </td>
                          <td>{convertAndFormatTimestamp(tt?.date) }</td>
                          <td style={{ color : tt?.payment_status_msg === "Processing" ||
                                  tt?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : tt?.payment_status_msg === "Failed"
                                    ? "red"
                                    : "green", fontWeight : '700'}}>{tt?.payment_status_msg }</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) :  state === "Electricity" ? (
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Total</th>
                      <th scope="col">Date</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                   console.log(tt , 'kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk');
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }

                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>{tt?.phone }</td>
                          <td>
                            <p>
                              Pg transaction Id : {tt?.pg_transactionId  }
                            </p>
                            <p>Xopay Id : {tt?.xopayid  }</p>

                            <p>
                              Payment Method :{" "}
                              {paymensss?.data?.payment?.payment_group }
                            </p>
                            <p style={{ fontWeight : '700' }}>₹ {tt?.total  }</p>
                          </td>
                          <td>{convertAndFormatTimestamp(tt?.date)  }</td>
                          <td style={{ color:
                                    tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : tt?.payment_status_msg === "Success"
                                      ? "green"
                                      : "orange",
                                  fontWeight : '700'}}>{tt?.payment_status_msg  }</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) :(
              <div style={{ marginTop: 20 }}>
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Total</th>
                      <th scope="col">Date</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((tt, index) => {
                      
                      let paymensss = {};

                      if (tt?.pg_res != undefined) {
                        paymensss = JSON.parse(tt?.pg_res);
                      }

                      return (
                        <tr
                          onClick={() => {
                            togglePanel(tt);
                          }}
                        >
                          <th scope="row">
                            {val}
                            {index + 1}
                          </th>
                          <td>{tt?.phone }</td>
                          <td>
                            <p>
                              Pg transaction Id : {tt?.pg_transactionId }
                            </p>
                            <p>Xopay Id : {tt?.xopayid }</p>

                            <p>
                              Payment Method :{" "}
                              {paymensss?.data?.payment?.payment_group }
                            </p>
                            <p>₹ {tt?.total }</p>
                          </td>
                          <td>{convertAndFormatTimestamp(tt?.date) }</td>
                          <td>{tt?.payment_status_msg }</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            <div style={{ marginTop: 20 }}>
              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={count / 10}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
              />

              {/* <div className="row">
                {data?.map((tt, index) => {
                  return (
                    <div
                      className="col-4 mt-4"
                      
                    >
                      <p
                        style={{
                          marginBottom: 0,
                          fontSize: 11,
                          cursor: "pointer",
                        }}
                      >
                        {tt?.phone}
                      </p>
                      <div className="row">
                        <p
                          style={{
                            marginBottom: 0,
                            fontSize: 11,
                            cursor: "pointer",
                          }}
                        >
                          ₹ {tt?.total}
                        </p>
                        <p
                          style={{
                            marginBottom: 0,
                            fontSize: 11,
                            cursor: "pointer",
                          }}
                        >
                          {convertAndFormatTimestamp(tt?.date)}
                        </p>
                      </div>
                      <div className="row">
                        <p
                          className="col"
                          style={{
                            marginBottom: 0,
                            fontSize: 11,
                            cursor: "pointer",
                          }}
                        >
                          {tt?.status}
                        </p>
                        <p
                          className="col"
                          style={{
                            marginBottom: 0,
                            fontSize: 11,
                            color:
                              tt?.payment_status_msg === "Success"
                                ? "green"
                                : "red",
                            cursor: "pointer",
                          }}
                        >
                          {tt?.payment_status_msg}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className={`side-panel ${isOpen ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          <p style={{ fontWeight: "700" }}>{one?.category} Detail</p>
          {one?.category === "Fastag" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Vehicle Number</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName}</p>
                <p style={{ fontSize: 11 }}>{ddta?.vehicleNumber}</p>
                <p style={{ fontSize: 11 }}>{one?.phone}</p>
                <p style={{ fontSize: 11 }}>₹ {one?.total}</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date)}
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId}</p>
              </div>
            </div>
          ) : one?.category === "LPG Gas" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName }</p>
                <p style={{ fontSize: 11 }}>
                  {one?.phone === undefined ? "NA" : one?.phone}
                </p>
                <p style={{ fontSize: 11 }}>₹ {one?.total }</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date) }
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId }</p>
              </div>
            </div>
          ) : one?.category === "Electricity" ? (
            <div className="row">
              <div className="col-6">
                <p style={{ fontSize: 11 }}>Name</p>
                <p style={{ fontSize: 11 }}>Phone</p>
                <p style={{ fontSize: 11 }}>Amount</p>
                <p style={{ fontSize: 11 }}>Consumer Number</p>
                <p style={{ fontSize: 11 }}>Date</p>
                <p style={{ fontSize: 11 }}>RequestId</p>
              </div>
              <div className="col-6">
                <p style={{ fontSize: 11 }}>{ddta?.customerName }</p>
                <p style={{ fontSize: 11 }}>
                  {one?.phone === undefined ? "NA" : one?.phone}
                </p>
                <p style={{ fontSize: 11 }}>₹ {one?.total }</p>
                <p style={{ fontSize: 11 }}>{ddta?.consumerNumber }</p>
                <p style={{ fontSize: 11 }}>
                  {convertAndFormatTimestamp(ddta?.date) }
                </p>
                <p style={{ fontSize: 11 }}>{ddta?.requestId }</p>
              </div>
            </div>
          ) : (
            ""
          )}

          <p style={{ fontWeight: "700" }}>User Detail</p>
          <div className="row">
            <div className="col-6">
              <div>
                <p>Name : {one?.user?.name }</p>
                <p>Phone No : {one?.user?.phoneno }</p>
                <p>Email : {one?.user?.email }</p>
              </div>
            </div>

            <div className="col-6">
              <div>
                <p
                  style={{
                    color:
                      one?.payment_status_msg === "Failed"
                        ? "red"
                        : one?.payment_status_msg === "Success"
                        ? "green"
                        : "orange",
                  }}
                >
                  {one?.payment_status_msg }
                </p>

                {one?.payment_status_msg === "Success" ||
                ser === true ||
                one?.payment_status_msg === "Failed" ||
                one?.payment_status_msg === "Refund" ? (
                  ""
                ) : (
                  <button
                    onClick={() => {
                      retry(one);
                    }}
                  >
                    Retry
                  </button>
                )}
              </div>
            </div>
          </div>

          <div style={{ justifyContent: "space-evenly", display: "flex" }}>
            <select
              onChange={(e) => {
                console.log(e.target.value);
                setVals(e.target.value);
              }}
            >
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
              <option value="Progress">Progress</option>
              <option value="Refund">Refund</option>
            </select>

            <button
              onClick={() => {
                submit();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editbbps;
